<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img src="@/assets/admin-icon/customers-active.svg" />
          <pathViewer></pathViewer>
        </div>
        <div class="ribbon-options"></div>
      </div>
    </div>
    <div class="page-body">
      <div class="tabs-widget">
        <div class="profile-widget">
          <img
            v-if="account.logo"
            :src="$fullUrl('images/profiles/' + account.logo)"
          />
          <img v-else src="@/assets/avatar.png" />
          <h3>{{ account.name | validate }}</h3>
          <p></p>
        </div>
        <div class="tabs-links">
          <div
            class="tab"
            style="justify-content: flex-start"
            :class="{ active: switch_tab == 'overview' }"
            @click="selectTab('overview')"
          >
            <span class="name">Overview</span>
          </div>

          <div
            class="tab"
            :class="{ active: switch_tab == 'projects' }"
            @click="selectTab('projects')"
          >
            <span class="name">Projects</span>
          </div>
          <div
            class="tab"
            :class="{ active: switch_tab == 'contacts' }"
            @click="selectTab('contacts')"
          >
            <span class="name">Contacts</span>
          </div>

          <div
            class="tab"
            :class="{ active: switch_tab == 'attachments' }"
            @click="selectTab('attachments')"
          >
            <span class="name">Attachements</span>
          </div>
        </div>
      </div>
      <div class="tab-body">
        <Overview
          v-if="switch_tab == 'overview'"
          @updateParent="getStartData()"
        ></Overview>
        <Events v-if="switch_tab == 'events'"></Events>
        <Projects v-if="switch_tab == 'projects'"></Projects>
        <Contacts v-if="switch_tab == 'contacts'"></Contacts>
        <Attachments v-if="switch_tab == 'attachments'"></Attachments>
      </div>
    </div>
  </div>
</template>
<script>
import Overview from "@/views/Accounts/AccountsView/Overview.vue";
import Projects from "@/views/Accounts/AccountsView/Projects.vue";
import Contacts from "@/views/Accounts/AccountsView/Contacts.vue";
import Attachments from "@/views/Accounts/AccountsView/Attachments.vue";
export default {
  name: "account-view",
  components: {
    Overview,
    Projects,
    Contacts,
    Attachments,
  },
  data() {
    return {
      switch_tab: "overview",
      account: {},
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.switch_tab = val;
    },
  },
  mounted() {
    let vm = this;
    vm.getStartData();
    if (vm.$route.params.type) {
      vm.switch_tab = vm.$route.params.type;
    }
  },
  methods: {
    getStartData() {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.account = responce.data;
        })
        .catch((error) => {});
    },
    onScoll({ target }) {
      // Modify header according to profile scoll
      let vm = this;
      vm.isScoll = true;
    },
    selectTab(type) {
      let vm = this;
      let path = [
        {
          label: "Accounts",
        },
        {
          label: type,
        },
      ];
      path.push({
        label: vm.account.name,
        active: true,
      });
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      padding: 10px 15px;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
  }
  .page-body {
    height: calc(100% - 50px);
    width: 100%;
    display: grid;
    overflow-x: hidden;
    overflow: hidden;
    position: relative;
    grid-template-columns: 20% 78%;
    padding: 0px 0px;
    padding-left: 15px;
    grid-column-gap: 10px;
    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: 100%;
      padding-left: 0px;
    }
    .tabs-widget {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      border-bottom: 1px solid #efefef;
      border-radius: 5px;
      @media (min-width: 300px) and (max-width: 630px) {
        flex-direction: row;
        justify-content: center;
      }
      .profile-widget {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          color: #0884af;
          object-fit: cover;
        }
        h3 {
          margin: 0px;
          font-size: 16px;
          margin-top: 10px;
        }
        p {
          color: #707070;
          margin: 0px;
          text-align: center;
        }
      }
      .tabs-links {
        display: flex;
        flex-direction: column;
        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: row;
        }
        .tab {
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
          }
          .name {
            display: block;
            font-size: 13px;
            @media (min-width: 300px) and (max-width: 630px) {
              //display: none;
            }
          }
          .icon {
            display: none;
            background: #dedede;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              display: flex;
            }
            img {
              width: 22.9px;
            }
          }
        }
        .tab.active {
          color: #fff;
          background: #0884af;
          font-weight: 800;
          .icon {
            background: #1890a9;
          }
        }
        .tab:hover {
          color: #fff;
          background: #0884af;
        }
      }
    }
    .tab-body {
      width: 100%;
      padding: 0px !important;
      height: calc(100vh - 50px);
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
